<div class="payment-request-wrapper">
  <span>Betaalverzoek van Viteezy</span>
  <div *ngIf="!loading && !allPaymentsPaid && !failed">
    <span class="payment-amount">{{ amount }}</span>
    <div>
      <button class="button submit-button" [disabled]="submitting" (click)="submitPayment()">Betalen</button>
      <div class="payment-methods">
        <div *ngFor="let paymentMethod of paymentMethods" class="payment-method">
          <img [src]="paymentMethod.image.svg">
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="allPaymentsPaid">
    <span class="paid">Betaald</span>
    <span class="signature">Bedankt!</span>
  </div>
  <div *ngIf="failed">
    <span>Dit betaalverzoek kunnen we op dit moment niet openen.</span>
    <span>Neem contact op met onze klantenservice via <a href="mailto:info@viteezy.nl">info&#64;viteezy.nl</a>, dan helpen we je snel verder.</span>
  </div>
</div>
